<template>
  <div
    class="wrapper"
    :class="padded && 'padded'"
  >
    <md-checkbox
      v-if="!isLoading"
      :value="!isChecked"
      @change="onChange()"
    />

    <md-progress-spinner
      v-else
      md-mode="indeterminate"
      :md-diameter="18"
    />
  </div>
</template>
<script>
    export default {
        props: {
            isLoading: {
                type: Boolean,
                default: false
            },
            isChecked: {
                type: Boolean,
                default: false
            },
            padded: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onChange() {
                this.$emit("change");
            }
        }
    };
</script>
<style scoped>
    .wrapper {
        display: flex !important;
        align-items: center;
        justify-content: center;
        margin: 16px 0 16px 8px !important;
    }
    .padded {
        padding-left: 50% !important;
    }
</style>
